@let type = typeSg();
@let value = valueSg();
@let valueInfo = valueInfoSg();

@let listValue = listValueSg();
@let booleanValue = booleanValueSg();
@let dateRangeValue = dateRangeValueSg();
@let dateMultirangeValue = dateMultirangeValueSg();
@let dateValue = dateValueSg();

<!-- ----------------------------------------------------------------------- -->
<!--                     Structure types (list / object)                     -->
<!-- ----------------------------------------------------------------------- -->
@if (listValue) {
  <atn-list-content [value]="listValue" />
} @else if (booleanValue) {
  <atn-boolean-content [value]="booleanValue" />
} @else if (dateRangeValue) {
  <atn-date-range-content [value]="dateRangeValue" />
} @else if (dateMultirangeValue) {
  @for (range of dateMultirangeValue.ranges; track $index) {
    <atn-date-range-content [value]="range" />
  } @empty {
    <atn-date-range-content />
  }
} @else {
  @switch (type) {
    <!-- ----------------------------------------------------------------------- -->
    <!--                             Numerical types                             -->
    <!-- ----------------------------------------------------------------------- -->
    @case (IntrinsicEnum.Currency) {
      <atn-number-content
        [value]="value"
        [valueInfo]="valueInfo"
      />
    }
    @case (IntrinsicEnum.Integer) {
      <atn-number-content
        [value]="value"
        [valueInfo]="valueInfo"
      />
    }
    @case (IntrinsicEnum.Percent) {
      <atn-number-content
        [value]="value"
        [valueInfo]="valueInfo"
      />
    }
    @case (IntrinsicEnum.Date) {
      <atn-date-content [value]="dateValue" />
    }
    @default {
      <!-- Fallback to standard component when type is not explicitly handled in
      switch cases above -->
      <atn-standard-content [value]="value" />
    }
  }
}
